import request from "@/router/axios";

// 获取巡检任务列表
export const getList = (data) => {
  return request({
    url: "/api/produce/inspection-worko-rder/select/page/current-user",
    method: "post",
    data,
  });
};

// 新增巡检任务
export const add = (row) => {
  return request({
    url: "/api/produce/inspection-worko-rder/insert",
    method: "post",
    data: row,
  });
};

// 获取巡检任务详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/inspection-worko-rder/select/id",
    method: "get",
    params: {
      id,
    },
  });
};

// 更新巡检任务
export const update = (row) => {
  return request({
    url: "/api/produce/inspection-worko-rder/update",
    method: "post",
    data: row,
  });
};

// 删除巡检任务
export const remove = (ids) => {
  return request({
    url: "/api/produce/inspection-worko-rder/delete/ids",
    method: "get",
    params: {
      ids,
    },
  });
};

// 获取计划名称列表
export const getPlanList = () => {
  return request({
    url: "/api/produce/inspection-plan/select/list",
    method: "get",
  });
};

// 获取巡检路线列表
export const getRouteList = () => {
  return request({
    url: "/api/produce/inspection-route/select/list",
    method: "get",
  });
};

// 获取巡检人员列表
export const getPersonnelList = () => {
  return request({
    url: "/api/produce/inspection-personnel/select/list",
    method: "get",
  });
};

// 启动定时任务 - 创建今日任务
export const createTodayTasks = () => {
  return request({
    url: "/api/produce/inspection-task-job/create-today-tasks",
    method: "post",
  });
};

// 分页查询检验工单扩展信息（去重）
export const distinctPage = (row) => {
  return request({
    url: "/api/produce/inspection-work-order-ext/select/page",
    method: "post",
    data: row,
  });
};
// 创建工单
export const insert = (row) => {
  return request({
    url: "/api/produce/work-order/insert",
    method: "post",
    data: row,
  });
};
